/**
 * What the Brand Presence lists that page through Sync Core share: the rows a page may show, the size
 * a list opens on, how that size travels in the address, and how long a search waits after the last
 * keystroke before it asks. The content inventory and the issue list read them from here, so the two
 * lists offer the same choice.
 */

/** The row counts a list offers, and the one it opens on: a page size fit for working through. */
export const BRAND_PRESENCE_LIST_PAGE_SIZES = [25, 50, 100] as const;
export const DEFAULT_BRAND_PRESENCE_LIST_PAGE_SIZE: (typeof BRAND_PRESENCE_LIST_PAGE_SIZES)[number] = 25;

/** How long a list's search waits after the last keystroke before it asks. */
export const BRAND_PRESENCE_LIST_SEARCH_DEBOUNCE_MS = 350;

/** The page size an address token names, or the default where it names none the lists offer. */
export function parsePageSizeToken(token: string | null | undefined): number {
  const parsed = Number(token);
  return (BRAND_PRESENCE_LIST_PAGE_SIZES as readonly number[]).includes(parsed) ? parsed : DEFAULT_BRAND_PRESENCE_LIST_PAGE_SIZE;
}

/** The address token a page size round-trips through: nothing for the default, the number otherwise. */
export function pageSizeToToken(pageSize: number): string | undefined {
  return pageSize === DEFAULT_BRAND_PRESENCE_LIST_PAGE_SIZE ? undefined : String(pageSize);
}
